module.exports = __webpack_public_path__ + "static/media/assign staff in department.a98baaa5.svg";